import {
  Box,
  FormControl,
  FormHelperText,
  MenuItem,
  Select,
  styled,
  Tooltip,
  tooltipClasses,
  Typography,
} from "@mui/material";
import {
  plannerAreaInputs,
  plannerInputsAll,
} from "../../data/planner-areas";
import { useEffect, useState } from "react";
import { axiosInstance } from "../../services/api/api";

// svg
import { ReactComponent as IconTooltip } from "../../assets/svg/help-circle.svg";
import { ReactComponent as IconReload } from "../../assets/svg/reload.svg";
import { usePlannerContext } from "../../services/context/planner-context";
import { functionalTypesId } from "../../constants/planner.constants";
import { TooltipWithIconCustom } from "./tooltip-custom";
import { CAR_PARKING_TYPE } from "../../constants/global.constants";



export const BasicSelectType = ({
  label,
  unit,
  list,
  value,
  setValue,
  nodeData,
  setLoading,
  type,
  tooltip,
  disabled = false
}) => {
  const { validateStart, setValidateEnd, setErrors, nodes, buildingsTypes } =
    usePlannerContext();

  const hasCarPark = !!nodes.find(
    (item) => item.data.type === CAR_PARKING_TYPE
  );
  const buildingsCount = nodes.filter(
    (item) => item.data.type !== CAR_PARKING_TYPE
  ).length;


  const [error, setError] = useState(false);

  const updateBuilding = async (
    buildingId,
    buildingInputs,
    selectedTypeObj
  ) => {
    /* setLoading(true); */
    setError(null);
    try {
      const response = await axiosInstance.put(
        `/buildings/updateBuilding/${buildingId}`,
        { ...buildingInputs }
      );


      setValue(selectedTypeObj, buildingInputs);
    } catch (error) {
      // Handle error
      setError(error.response ? error.response.data.message : error.message);
    } finally {
      setLoading(false);
    }
  };

  const updateInputsForType = (newTypeInputs, currentInputs) => {
    const newInputs = {};
    const newInputFields = Object.keys(newTypeInputs);

    newInputFields.forEach((field) => {
      if (currentInputs.hasOwnProperty(field)) {
        newInputs[field] = currentInputs[field];
      } else {
        newInputs[field] = -1;
      }
    });

    return newInputs;
  };

  const handleChangeType = (e) => {
    const selectedTypeId = e.target.value;
    const selectedTypeObj = list.find(
      (item) => item.id === selectedTypeId
    );

    if (
      nodeData &&
      nodeData.buildingId &&
      selectedTypeObj &&
      selectedTypeId !== nodeData.typeId
    ) {
      const newTypeInputs = plannerAreaInputs[selectedTypeObj.node_name];
      const prefieldInputs = updateInputsForType(
        newTypeInputs,
        nodeData.building
      );
      const updatedInputs = { ...plannerInputsAll, ...prefieldInputs };

      const buildingInputs = {
        ...nodeData.building,
        buildingType: selectedTypeObj.id,
        ...updatedInputs,
      };

      updateBuilding(nodeData.buildingId, buildingInputs, selectedTypeObj);
    }
  };

  useEffect(() => {
    if (validateStart > 0) {
      if (error) {
        setErrors((prev) => prev + 1);
      }
      setValidateEnd((prev) => prev + 1);
    }
  }, [validateStart]);

  return (
    <FormControl
      error={!!error}
      /* variant="standard" */
      sx={{ width: "100%" }}
    >
      <Box sx={{ width: "100%", display: "flex", flexDirection: "column" }}>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "2px",
            /* mb: "4px", */
            padding: "0px 0px 0px 8px",
          }}
        >
          <TooltipWithIconCustom text={tooltip} >
            <Typography
              sx={{
                fontSize: "12px",
                color: "#343745",
                fontWeight: 500,
                lineHeight: 1.9,
              }}
            >
              {label}{" "}
              {unit && <span style={{ color: "#a2a3a3" }}>[{unit}]</span>}
            </Typography>
          </TooltipWithIconCustom>

          {/* {loading && <CircularProgress size={15} />} */}
          {/* {error && (
          <IconButton sx={{ padding: "4px" }} onClick={reloadHandler}>
            <IconReload stroke="#ba1a1a" width={"14px"} height={"14px"} />
          </IconButton>
        )} */}
        </Box>

        <Select
        disabled={disabled}
          value={value}
          onChange={handleChangeType}
          name={"functional type"}
          size="small"
          className="nodrag nopan"
          sx={{
            fontSize: "14px",
            "& .MuiSelect-select": {
              padding: "8.5px 8px",
            },
            "&.MuiInputBase-root": {
              borderRadius: "8px",
              background: "#fff",
            },
            "&.MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "#dbdbeb",
                borderWidth: "1px",
                transition:
                  "border-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
              },
              "&:hover fieldset": {
                borderColor: "#efa21e",
                borderWidth: "1px",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#efa21e",
                borderWidth: "1px",
              },
            },
          }}
        >
          {list.map((item) => (
            <MenuItem
              key={item.id}
              value={item.id}
              disabled={
                type !== CAR_PARKING_TYPE && item.node_name === CAR_PARKING_TYPE
                  ? hasCarPark
                  : type === CAR_PARKING_TYPE && item.node_name !== CAR_PARKING_TYPE
                  ? buildingsCount >= 10
                  : false
              }
            >
              {item.display_name}
            </MenuItem>
          ))}
        </Select>
        {error && (
          <FormHelperText
            sx={{ pl: "8px", ml: 0, mr: 0 }}
            id="component-error-text"
          >
            Failed to update the function type. Please reselect it again.
          </FormHelperText>
        )}
      </Box>
    </FormControl>
  );
};
